import { useEffect, useState } from "react";

import "./map.css";

const Map = ({ data }) => {
  const [topology, setTopology] = useState();
  useEffect(() => {
    const fetchTopology = async () => {
      const topologyRes = await fetch(
        "https://code.highcharts.com/mapdata/countries/id/id-all.topo.json",
      ).then((response) => response.json());
      setTopology(topologyRes);
    };
    fetchTopology();
  }, []);

  useEffect(() => {
    if (topology) {
      // Create the chart
      window.Highcharts.mapChart(
        "map-container",
        {
          chart: {
            map: topology,
          },

          title: {
            text: "",
          },

          mapNavigation: {
            enabled: true,
          },

          colorAxis: {
            min: 0,
            max: 100,
          },
          
          tooltip: {
            formatter: function() {
              return `<b>${this.point.name}</b>: ${this.point.value}%`;
            }
          },
          
          series: [
            {
              data: data,
              name: "",
              states: {
                hover: {
                  color: "#BADA55",
                },
              },
              dataLabels: {
                enabled: true,
                format: "{point.name}",
                nullFormat: "",
              },
            },
          ],
        },
        ...(data?.length === 1
          ? [
              (chart) => {
                if (chart?.series) {
                  for (const country of chart.series[0].data) {
                    if (Boolean(country?.value)) {
                      country.zoomTo();
                    }
                  }
                }
              },
            ]
          : []),
      );
    }
  }, [data, topology]);

  return <div id='map-container'></div>;
};

export default Map;
